// Auto-generated blocklist — do not render on HTML pages
const blockedWordsHi = [
  "aand",
  "aandu",
  "balatkar",
  "balatkari",
  "bhadva",
  "bhadve",
  "bhandve",
  "bhangi",
  "bhosad",
  "boobe",
  "chakke",
  "chinaal",
  "chinki",
  "chod",
  "chodu",
  "chooche",
  "choochi",
  "choope",
  "choot",
  "chootia",
  "chootiya",
  "chuche",
  "chuchi",
  "chudaap",
  "chude",
  "chut",
  "chutad",
  "chutadd",
  "chutan",
  "chutia",
  "chutiya",
  "gaand",
  "gaandfat",
  "gaandmasti",
  "gaandufad",
  "gandfattu",
  "gandu",
  "gashti",
  "gasti",
  "ghassa",
  "ghasti",
  "gucchi",
  "gucchu",
  "harami",
  "haramzade",
  "hawas",
  "hijda",
  "hijra",
  "jhant",
  "jhantu",
  "kamine",
  "kaminey",
  "kanjar",
  "kutta",
  "kuttiya",
  "loda",
  "lodu",
  "lund",
  "lundtopi",
  "lundure",
  "maal",
  "madarchod",
  "madhavchod",
  "mutth",
  "mutthal",
  "najayaz",
  "paki",
  "pataka",
  "patakha",
  "raand",
  "randaap",
  "randi",
  "saala",
  "suar",
  "tatte",
  "tatti",
  "tharak",
  "tharki"
];

export default blockedWordsHi;
